import logo from '../assets/logo.png'

const OathPage = () => {
  return (
    <div className='flex flex-col items-center py-16 px-4 max-w-7xl mx-auto'>
      <img className='h-72 mb-12' src={logo} alt="Code Scribes. Software by Master Craftsmen" />
      <h1 className='font-heading text-5xl text-primary-light tracking-tight mb-8'>The Scribe's Oath</h1>
      <ul className='space-y-4 text-lg font-body text-neutral-300 max-w-2xl'>
        <li className='border-l-2 border-primary pl-4'>I will give back to the tech community.</li>
        <li className='border-l-2 border-primary pl-4'>I shall not write code that could be harmful to others.</li>
        <li className='border-l-2 border-primary pl-4'>I will not allow temporary fixes to persist into permanent fixes.</li>
        <li className='border-l-2 border-primary pl-4'>I will work to prevent tribal knowledge from forming among my team.</li>
        <li className='border-l-2 border-primary pl-4'>I will build in public; committing code early and often.</li>
        <li className='border-l-2 border-primary pl-4'>I will prioritize shipping functional code over perfect code.</li>
        <li className='border-l-2 border-primary pl-4'>I will provide tests for my code proving its functionality.</li>
        <li className='border-l-2 border-primary pl-4'>I will follow proper coding discipline(s).</li>
        <li className='border-l-2 border-primary pl-4'>I will not engage in technical debate without a working prototype.</li>
        <li className='border-l-2 border-primary pl-4'>I will endlessly continue my learning and trying to master my craft.</li>
        <li className='border-l-2 border-primary pl-4'>I will take care of my physical & mental health.</li>
      </ul>
    </div>
  )
}

export default OathPage;
